import { createContext, useState } from "react"

export const SidebarContext = createContext()

const SidebarContextProvider = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(false)

  return (
    <SidebarContext.Provider value={{ showSidebar, setShowSidebar }}>
      {children}
    </SidebarContext.Provider>
  )
}

export default SidebarContextProvider
